import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ScrollToTopDirective } from "./scroll-to-top/scroll-to-top.directive";

export const GLOBAL_SCROLLBAR_DIRECTIVES: any[] = [ScrollToTopDirective];

@NgModule({
	imports: [CommonModule],
	exports: GLOBAL_SCROLLBAR_DIRECTIVES,
	declarations: GLOBAL_SCROLLBAR_DIRECTIVES,
})
export class GlobalUiScrollbarModule {}
